module.exports = __webpack_public_path__ + "static/img/93015A_R_2_3_4_20180406_LC.d892c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/93015A_R_2_3_4_20180406_LC.png
// module id = VwLN
// module chunks = 0